import { ACTIONS } from 'constants/hook';
import { UpdateFunction } from 'json-edit-react';

export const createUpdateFn = function <TCallbackData>(
  cb: (data: TCallbackData) => void,
): UpdateFunction {
  return ({ newData }) => {
    cb(newData as TCallbackData);
  };
};

export const createCallback = function (dispatch: (action: any) => void) {
  return {
    onAdd: createUpdateFn((newData: any) => dispatch({ payload: newData, type: ACTIONS.CHANGE })),
    onEdit: createUpdateFn((newData: any) => dispatch({ payload: newData, type: ACTIONS.CHANGE })),
    onDelete: createUpdateFn((newData: any) =>
      dispatch({ payload: newData, type: ACTIONS.CHANGE }),
    ),
  };
};
